var exports = {
  "n": "xe7b6e3d6--b7a009--row",
};

module.exports = exports;
